import { Popover } from "antd";

const CustomImage = ({ alt, src, size = "md" }: any) => {
  return (
    src && (
      <Popover
        placement="right"
        content={
          <img
            src={`${src}`}
            style={{ maxWidth: "70vw", maxHeight: "70vh" }}
            alt={alt}
          />
        }
      >
        <img
          src={`${src}`}
          style={{
            height: `${size == "md" ? "70px" : "35px"}`,
            width: `${size == "md" ? "70px" : "35px"}`,
            objectFit: "cover",
          }}
          alt={alt}
        />
      </Popover>
    )
  );
};

export default CustomImage;
